import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import './login.css';
import { decryptString } from "../../_services";
import CryptoJS from 'crypto-js';
import { API_URL, baseurl, projectNo } from "../../_config";
import { useNavigate } from "react-router-dom";
import CheckToken from "../../auth/authToken";
import OtpInput from "react-otp-input";
import { ToastContainer, toast } from "react-toastify";

// const baseUrl = process.env.REACT_APP_BASE_URL;

const Login = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    const [ph, setPh] = useState('');
    const [otp, setOtp] = useState('');
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [loginDetail, setLoginDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [jwtToken, setJwtToken] = useState('');

    const secretKey = CryptoJS.enc.Utf8.parse("uitsufdytuiysdifdsfdsfdhgtyuijkj");
    const iv = CryptoJS.enc.Utf8.parse("1234567890123456");

    const getLoginDetailByMobileNo = useCallback(async (mobileNo) => {
        if (mobileNo) {
            setLoading(true);
            try {
                const response = await axios.post(`${baseurl}${API_URL.login}`,
                    {
                        mobileNo: mobileNo
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }
                );
                if (response.status === 200 && response.data.isSuccess === 200) {


                    const encryptedData = response.data?.data;
                    if (!encryptedData || typeof encryptedData !== 'string' || encryptedData.trim() === '') {
                        throw new Error("Invalid or empty encrypted data format");
                    }

                    const result = decryptString(encryptedData, secretKey, iv);

                    const parsedData = JSON.parse(result);
                    setLoginDetail(parsedData[0]);

                    const token = response.data.token;
                    setJwtToken(token)

                } else {
                    setLoginDetail(null);
                }
            } catch (error) {
                setLoginDetail([])
            } finally {
                setLoading(false);
            }
        }
    }, [secretKey, iv]);

    useEffect(() => {
        getLoginDetailByMobileNo();
    }, [getLoginDetailByMobileNo])

    const validatePhoneNumber = (phone) => {
        const isValid = /^\d{10}$/.test(phone) && parseInt(phone[0], 10);
        return isValid;
    };

    const handleMobileChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');

        if (value !== numericValue) {
            alert("You can enter only numbers.");
        }

        setPh(numericValue.slice(0, 10));

        if (numericValue.length === 10) {
            getLoginDetailByMobileNo(numericValue);
        } else {
            setLoginDetail(null);
        }
    };

    const sendOtp = async () => {
        if (!validatePhoneNumber(ph)) {
            toast.error("Please Enter Valid Mobile Number");
            return;
        }

        const phoneNumber = ph.toString();
        if (!loginDetail) {
            alert("Mobile number is not registered");
            return;
        }

        setLoading(true);
        const apiUrl = `${baseurl}${API_URL.SentOtp}`;

        try {
            const response = await axios.post(apiUrl, {
                mobileNo: `${phoneNumber}`
            }, { timeout: 5000 });

            if (response.status === 200) {
                if (response.data.isSuccess === 200) {
                    setShowOtpInput(true);
                    toast.success("OTP Sent Successfully");
                }
            }
        } catch (error) {
            toast.error("Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    const handleOtpChange = (value) => {
        if (/^[0-9]*$/.test(value)) {
            setOtp(value);
        } else {
            alert("Please enter only numeric values for OTP.");
            return;
        }
    };

    const verifyOtp = async () => {
        if (!otp) {
            toast.error("Please enter the OTP");
            return;
        }
        localStorage.setItem('user', 'true');
        localStorage.setItem('loginId', loginDetail.loginId);
        localStorage.setItem('jwtToken', jwtToken);

        setLoading(true);
        const apiUrl = `${baseurl}${API_URL.VerifyOTP}`;

        try {
            const response = await axios.post(apiUrl, {
                mobileNo: `${ph}`,
                OTP: otp,
            });

            if (response.status === 200) {
                if (response.data.isSuccess === 200) {
                    toast.success("OTP Verified Successfully");
                    setIsLoggedIn(true)
                    navigate('/dashboard');
                } else {
                    toast.error("OTP Verification failed");
                }
            } else {
                toast.error("OTP Verification failed");
            }
        } catch (error) {
            toast.error("Failed to Verify OTP");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (showOtpInput) {
            verifyOtp();
        } else {
            sendOtp();
        }
    };

    return (
        <div className="login_main">
            <CheckToken setIsLoggedIn={setIsLoggedIn} />
            <ToastContainer
                autoClose={400}
                hideProgressBar={true}
                closeOnClick
                pauseOnHover
                draggable
                className='toaster'
            />
            <p className="d-none" style={{ display: 'none' }}>{isLoggedIn}</p>
            <div className="login_form">
                <div className={`${projectNo}login_logo_lifecode login_logo_lifecode`}>
                    <img className="" src={`./images/${projectNo}.png`} alt="" />
                </div>
                <h3 className="text-center mb-3 login_heading">LOGIN</h3>
                <form onSubmit={handleSubmit}>
                    {showOtpInput ? (
                        <div className="otp_input mt-2 d-flex justify-content-center">
                            <OtpInput
                                className="otpinput d-flex justify-content-center"
                                value={otp}
                                onChange={handleOtpChange}
                                numInputs={6}
                                renderSeparator={<span>-</span>}
                                renderInput={(props) => <input {...props} />}
                            />
                        </div>
                    ) : (
                        <div className="form-group">
                            <label className={`mb-2 ${projectNo}mobile_label`} htmlFor="mobileNo">Mobile Number</label>
                            <input
                                type="text"
                                className="form-control"
                                name="mobile"
                                id="mobile"
                                aria-describedby="emailHelp"
                                placeholder="Enter Mobile Number"
                                value={ph}
                                onChange={handleMobileChange}
                                disabled={showOtpInput}
                                style={{ flex: 1 }}
                                maxLength={10}
                            />
                        </div>
                    )}
                    <div className="login_btn_wepper">
                        <button
                            type="submit"
                            className={`login_btn ${projectNo}`}
                            // onClick={showOtpInput ? verifyOtp : sendOtp}
                            disabled={loading}
                        >
                            {showOtpInput ? 'Verify OTP' : 'Send OTP'}
                        </button>
                    </div>
                </form>
                {showOtpInput ? <p
                    onClick={sendOtp}
                    disabled={loading}
                    className="resend_otp pt-1"
                    style={{ color: '#7471fd', cursor: 'pointer' }}
                >Resend</p> : null}
            </div>
        </div>
    )
}

export default Login;